export const LocationValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.vc_Name.trim()) {
      errors.vc_Name = ' Name is required';
    } 
    if (!formData.vc_Telephone.trim()) {
        errors.vc_Telephone = ' Telephone is required';
      } 
      if (!formData.vc_Address1.trim()) {
        errors.vc_Address1 = ' Address 1 is required';
      } 
    return errors;
  };
  
 